
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import Container from "../ui/Container";
import { articles } from "@/data/articles";

const News = () => {  
  const news = articles
  .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
  .slice(0, 3);
  

  return (
    <section className="py-20 bg-secondary relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute right-0 top-1/4 w-1/3 h-1/3 bg-primary/5 rounded-full blur-3xl"></div>
        <div className="absolute left-0 bottom-1/4 w-1/3 h-1/3 bg-accent/5 rounded-full blur-3xl"></div>
      </div>

      <Container>
        <div className="flex flex-col lg:flex-row justify-between items-start mb-12">
          <div className="lg:w-1/2 mb-8 lg:mb-0">
            <div className="tag mb-4">Новости и обновления</div>
            <h2 className="heading text-3xl md:text-4xl font-bold mb-6">
              Последние <span className="text-gradient">новости</span> и события
            </h2>
            <p className="text-muted-foreground text-lg">
              Будьте в курсе последних новостей, обновлений продуктов и полезных статей от нашей команды экспертов.
            </p>
          </div>
          <div className="lg:w-auto">
            <Link to="/news" className="button-primary">
              Все новости
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {news.map((item) => (
            <article 
              key={item.id} 
              className="relative group bg-white rounded-2xl overflow-hidden shadow-sm border border-border hover:border-primary/20 hover:shadow-md transition-all duration-300"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-accent/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="relative z-10">
                <div className="p-6">
                  <div className="flex items-center justify-between mb-4">
                    <div className="tag">{item.category}</div>
                    <div className="text-sm text-muted-foreground">{item.date.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' })}</div>
                  </div>
                  <h3 className="text-xl font-semibold mb-3 group-hover:text-primary transition-colors duration-200">
                    {item.title}
                  </h3>
                  <p className="text-muted-foreground mb-5 text-sm">
                    {item.excerpt}
                  </p>
                  <Link 
                    to={`/news/${item.id}`} 
                    className="inline-flex items-center text-primary font-medium"
                  >
                    Читать далее
                    <ArrowRight className="ml-2 h-4 w-4 transform group-hover:translate-x-1 transition-transform duration-200" />
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default News;
